import React from 'react';
import { bool, shape, string } from 'prop-types';

const Plowing = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 7H4V10.7998L5.59961 17H8V19H4.2998L2 11.2002V5H6V7Z" fill="currentColor" />
    <path d="M12 7H10V10.7998L11.5996 17H14V19H10.2998L8.23535 12H6.5C5.9 12 5.5 11.6 5.5 11C5.5 10.4 5.9 10 6.5 10H8V5H12V7Z" fill="currentColor" />
    <path d="M18 9.7998C18.4971 9.7998 18.9004 10.3373 18.9004 11C18.9003 11.6627 18.497 12.2002 18 12.2002C17.503 12.2001 17.1007 11.6626 17.1006 11C17.1006 10.3373 17.503 9.79987 18 9.7998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M22 19H16.4004L14.2461 12H12.5C11.9 12 11.5 11.6 11.5 11C11.5 10.4 11.9 10 12.5 10H14V5H22V19ZM16 10.7998L17.5996 17H20V7H16V10.7998Z" fill="currentColor" />
  </svg>
);

Plowing.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Plowing;
